export const formatSubjectPropertiesArray = (properties) => {
  if (!properties) return "N/A";
  if (Array.isArray(properties)) {
    return properties
      .map((prop) => prop.address?.fullAddress || prop)
      .join(", ");
  }
  return properties;
};
